module.exports = __webpack_public_path__ + "static/img/avatar-left.3e528d27.png";